import FormItem from '../form/src/form-item';

FormItem.install = function(Vue) {
  Vue.component(FormItem.name, FormItem);
};

export default FormItem;



// WEBPACK FOOTER //
// ./src/components/form-item/index.js